import { h, Fragment } from 'preact';

interface TransProps {
  children: string;
  values?: Record<string, preact.ComponentChildren>;
  style?: preact.JSX.CSSProperties;
}

export function Trans({ children, values = {}, style }: TransProps) {
  const parts = children.split(/({{\s*\w+\s*}})/g);

  return (
    <div style={style}>
      {parts.map((part, i) => {
        const match = part.match(/^{{\s*(\w+)\s*}}$/);
        if (match) {
          const key = match[1];
          return values[key] !== undefined ? <Fragment key={i}>{values[key]}</Fragment> : null;
        }
        return <Fragment key={i}>{part}</Fragment>;
      })}
    </div>
  );
}
